import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Checkbox from '../../Input/Checkbox';

import './Consent.less';

export class Consent extends React.Component {
    static displayName = 'Module.UserSettings.PrivacyView.Consent';
    static propTypes = {
        t: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    onChange = (isChecked) => {
        this.props.onChange(isChecked);
    }

    render() {
        const { t, url } = this.props;
        var isRequiredToCheck = !this.props.isChecked && this.props.isRequired;
        return (
            <div className="row">
                <div className="control-group col-md-12 ">
                    <div className="col-md-3 label-wrapper">
                        <div className="left-label">
                            {t(this.props.title)}
                            {this.props.isRequired && '*'}
                        </div>
                    </div>
                    <div className="controls col-md-7">
                        <Checkbox onChange={(event) => this.onChange(event.state.checked)}
                            checked={this.props.isChecked}
                            key={Math.random()}
                            id={"privacy_settings_consent_type_" + this.props.type} />
                        <span className="info_text">
                            {t(this.props.description)}
                        </span>
                        {url && <span><span> </span><a className="read-more-link" href={url} target="_blank">{t('marketing:landing_page.link.read_more', 'Read more')}</a></span>}
                        {isRequiredToCheck && <div className="consent-acceptance-required">
                            {t('gdpr:consents.popup.box_unchecked', 'You need to check this box to continue')}
                        </div>}
                        <p className="help-block" />
                    </div>
                </div>
            </div>
        );
    }
}

Consent.propTypes = {
    isChecked: PropTypes.bool,
    isRequired: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    onChange: PropTypes.func,
    t: PropTypes.func,
    type: PropTypes.string,
    url: PropTypes.string
};

export default translate(['common', 'gdpr', 'marketing'], { wait: true })(Consent);



// WEBPACK FOOTER //
// ./src/UserSettings/components/PrivacyView/Consent/index.jsx